import angular from 'angular';
import uiRouter from 'angular-ui-router';
import uiBootstrap from 'angular-ui-bootstrap';

import templateSupport from './support.html';
import templatePrivacy from './privacy.html';
import templateChildrensPrivacy from './childrensPrivacy.html';
import templateTerms from './terms.html';
import template404 from './404.html';

import { ServicesModule } from '../services/services.module';

import { LoginModule } from './login/login.module';
import { SignupModule } from './signup/signup.module';
import { ResetPwModule } from './resetPw/resetPassword.module';
import { ResetMobilePwModule } from './resetMobilePw/resetMobilePassword.module';
import { PatientConnectionModule } from './patientConnection/patientConnection.module';
import { DashboardModule } from "./dashboard/dashboard.module";
import { IndexModule } from "./index/index.module"

export const PagesModule = angular
    .module('mmsApp.pages', [
        uiRouter,
        uiBootstrap,
        ServicesModule,

        LoginModule,
        SignupModule,
        ResetPwModule,
        ResetMobilePwModule,
        PatientConnectionModule,
        DashboardModule,
        IndexModule
    ])
    .config(($stateProvider, $urlRouterProvider) => {
        'ngInject';
        $stateProvider
            .state('pages', {
                data: {
                    isAuthRequired: true
                },
                redirectTo: 'pages.index',
                template: `
                        <div class="app-container" id="container">
                            <div class='app-view' ui-view></div>                                                    
                        </div>                                                    
                    `,
            })
            .state('pages.support', {
                data: {
                    isAuthRequired: false,
                },
                url: '/support',
                template: `
                        <mms-banner ng-if="mobileType != 'iosapp' && mobileType != 'androidapp'"></mms-banner>
                        ${templateSupport}
                        <mms-footer></mms-footer>
                    `,
                controller: ['$scope', 'UtilService', '$uibModal', function ($scope, UtilService, $uibModal) {
                    $scope.mobileType = UtilService.getMobileType();

                    $scope.getMailTo = function () {
                        const to = 'MyMedSchedule Plus Support <info4@medactionplan.com>';
                        const subject = 'MyMedSchedule Plus Support Request';
                        const device = $scope.mobileType ? 'Device type: ' + $scope.mobileType + '\n' : '';
                        const body = `Name: 
                                          Phone: 
                                          ${device}
                                          Message:
                                          
                                          
                                        `.replace(/^( )+/gm, '');
                        return `mailto:${encodeURIComponent(to)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
                    }

                    $scope.openFaqModal = function (faqId) {
                        let modalInstance = $uibModal.open({
                            backdropClass: 'mms-backdrop',
                            templateUrl: faqId,
                            scope: $scope,
                            windowClass: 'modal-faq'
                        });
                        modalInstance.result.catch(() => { });
                    }
                }],
            })
            .state('pages.privacy', {
                data: {
                    isAuthRequired: false,
                },
                url: '/privacy',
                template: `
                        <mms-banner ng-if="mobileType != 'iosapp' && mobileType != 'androidapp'"></mms-banner>
                        ${templatePrivacy}
                        <mms-footer></mms-footer>
                    `,
                controller: ['$scope', 'UtilService', function ($scope, UtilService) {
                    $scope.mobileType = UtilService.getMobileType();
                }]
            })
            .state('pages.childrensPrivacy', {
                data: {
                    isAuthRequired: false,
                },
                url: '/childrens-privacy',
                template: `
                        <mms-banner ng-if="mobileType != 'iosapp' && mobileType != 'androidapp'"></mms-banner>
                        ${templateChildrensPrivacy}
                        <mms-footer></mms-footer>
                    `,
                controller: ['$scope', 'UtilService', function ($scope, UtilService) {
                    $scope.mobileType = UtilService.getMobileType();
                }]
            })
            .state('pages.terms', {
                data: {
                    isAuthRequired: false,
                },
                url: '/terms',
                template: `
                        <mms-banner ng-if="mobileType != 'iosapp' && mobileType != 'androidapp'"></mms-banner>
                        ${templateTerms}
                        <mms-footer></mms-footer>
                    `,
                controller: ['$scope', 'UtilService', function ($scope, UtilService) {
                    $scope.mobileType = UtilService.getMobileType();
                }]
            })
            .state('pages.404', {
                data: {
                    isAuthRequired: false,
                },
                template: template404
            });

        $urlRouterProvider.otherwise(function ($injector, $location) {
            $injector.get('$state').go('pages.404', undefined, { location: false, reload: true });
        });
    })
    .run(($transitions, $uibModal, AppUserService, $state) => {
        'ngInject';
        let requiresAuthCriteria = {
            to: (state) => state.data && state.data.isAuthRequired
        };
        $transitions.onBefore({ to: () => true }, transition => {
            console.log(transition.toString())
        })
        $transitions.onBefore(requiresAuthCriteria, redirectNonAuth);
        function redirectNonAuth(transition) {
            console.log("redirect non auth")
            let AppUserService = transition.injector().get('AppUserService');
            let $state = transition.router.stateService;
            if (!AppUserService.isAuthenticated()) {
                // Don't update url in location bar
                return $state.target('pages.index', undefined, { location: false });
            }
        }

        // Prompt user to authorize HIPAA if needed
        $transitions.onSuccess({ to: (state) => state.data && state.data.isAuthRequired }, (transition) => {
            let AppUserService = transition.injector().get('AppUserService');
            if (!AppUserService.isHipaaAuthorized()) {
                let modalInstance = $uibModal.open({
                    backdrop: 'static',
                    backdropClass: 'mms-backdrop',
                    component: 'mmsHipaaAuthorization',
                    resolve: {
                        userFullName: () => AppUserService.getUserFullName()
                    }
                });
                modalInstance.result
                    .then((result) => {
                        AppUserService.authorizeHipaa(result)
                    }).catch((result) => {
                        // User did not agree, sign out and redirect to login
                        AppUserService.authorizeHipaa(result)
                        AppUserService.logOutUser()
                        $state.go('pages.index')
                    });
            }
        });
    })
    .name
    ;



// WEBPACK FOOTER //
// ./src/app/pages/pages.module.js